<script>
</script>

<style>
  #bg-img-credit { display: none; }

  @media (min-width: 1244px) {
    #bg-img-credit {
      display: block;
    }
  }
</style>

<template lang="pug" src="./footer.pug"></template>
